import React from 'react';
import pickRunway from '../Runway/pickRunway';
import './SuggestedRunway.css';

function SuggestedRunway(props) {
  const suggestion = pickRunway(+props.runwayB, +props.runwayA, +props.wind, +props.historicWind);
  return (
    <div className="suggested-runway-container">
      <div className="suggested-runway glow-box">
        Use Runway <span className="runway-suggestion">{ suggestion }</span>
      </div>
      <div className="runway-grid">
        <div className="runway-container">
          <div className="runway north">{props.runwayA}</div>
          <div className="runway south">{props.runwayB}</div>
        </div>
      </div>
    </div>
  );  
}

export default SuggestedRunway;


/** WEBPACK FOOTER **
 ** ./src/SuggestedRunway/SuggestedRunway.js
 **/